<template>
    <b-modal
        :id="id"
        :title="title"
        centered
        no-close-on-backdrop
        hide-header-close
    >
        <div class="row">
            <div class="form-group col-12">
                <label for="name">Name</label>
                <input
                    id="name"
                    v-model="formData.name"
                    type="text"
                    class="form-control"
                    :class="{
                        'is-invalid': hasError('name')
                    }"
                    dir="auto"
                    placeholder="Name"
                />
                <div class="invalid-feedback">
                    {{ getError('name') }}
                </div>
            </div>
            <div class="form-group col-12">
                <label for="unit">Unit</label>
                <input
                    id="unit"
                    v-model="formData.unit"
                    type="text"
                    class="form-control"
                    :class="{
                        'is-invalid': hasError('unit')
                    }"
                    dir="auto"
                    placeholder="Unit"
                />
                <div class="invalid-feedback">
                    {{ getError('unit') }}
                </div>
            </div>
        </div>
        <template #modal-footer>
            <div class="col-12 d-flex justify-content-between">
                <button
                    type="button"
                    class="btn btn-danger waves-effect waves-light mr-2"
                    @click="close"
                >
                    Close
                </button>
                <button
                    type="submit"
                    class="btn btn-success waves-effect waves-light"
                    @click="save"
                >
                    Save
                </button>
            </div>
        </template>
    </b-modal>
</template>

<script>
import { mapActions } from 'vuex';
import { required } from 'vuelidate/lib/validators';
import { StatusCodes as HTTP } from 'http-status-codes';

export default {
    validations: {
        formData: {
            name: {
                required
            },
            unit: {}
        }
    },

    props: {
        id: {
            type: String,
            required: false,
            default: 'add-edit-attribute-group'
        },
        group: {
            type: Object,
            required: false,
            default: null
        }
    },

    data() {
        return {
            formData: {},
            serverErrors: []
        };
    },

    computed: {
        editMode() {
            return !!this.group;
        },

        title() {
            return this.editMode ? 'Edit group' : 'Add group';
        }
    },

    watch: {
        group(val) {
            this.formData = val ? { ...val } : {};
        }
    },

    methods: {
        ...mapActions({
            addGroup: 'attributeGroups/store',
            updateGroup: 'attributeGroups/update'
        }),

        close() {
            this.$emit('close');
            this.$bvModal.hide(this.id);
            this.$v.$reset();
            this.formData = {};
        },

        async save() {
            this.serverErrors = [];

            this.$v.$touch();

            if (this.$v.$invalid) {
                return;
            }

            if (!this.formData.unit) {
                this.formData.unit = null;
            }

            try {
                if (!this.editMode) {
                    const addedItem = await this.addGroup(this.formData);

                    this.$emit('stored', addedItem);
                    this.$toaster('Group added!');
                } else {
                    const updatedItem = await this.updateGroup({
                        id: this.group.id,
                        data: this.formData
                    });

                    this.$emit('updated', updatedItem);
                    this.$toaster('Group updated!');
                }

                this.close();
            } catch (error) {
                const { response } = error;

                if (response) {
                    const { data, status } = response;

                    if (status === HTTP.BAD_REQUEST && data.errors) {
                        this.serverErrors = data.errors;

                        this.$toasterError('Recheck your form.');

                        return;
                    }
                }

                console.error(error);

                this.$toasterError();
            }
        },

        hasError(key) {
            return (
                this.$v.formData[key].$error ||
                this.serverErrors.find(error => error.param === key)
            );
        },

        getError(key) {
            return this.$getValidationErrorMessageHandler.handle(
                this.$v.formData,
                this.serverErrors,
                key
            );
        }
    }
};
</script>
